@if (!company()) {
  <div gs1Spinner [big]="true" [size]="'50px'" style="left: 7%; margin-top: 20px;"></div>
}

<gs1-side-menu
  style="position: fixed; height: calc(100% - var(--footer-height));"
  [company]="company()"
  [menuItems]="menuItems"
  [footerSlot]="footerSlot"
  [width]="menuWidth"
  [clickableCompany]="storageService.hasMultipleCompanies"
  (onCompanySelect)="changeCompany()"
>
  <app-side-menu-certificate gs1SideMenuFooter />
</gs1-side-menu>
